import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import styles from './PauseSlideContentV10.css';

function PauseSlideContentV10({ imageSrc, heading, description, highlightIcon, highlightText, spriteVersion }) {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>{heading}</h2>
                <p className={styles.description}>{description}</p>
            </div>
            {Boolean(imageSrc) && (
                <div className={styles.imageWrapper}>
                    <img src={imageSrc} alt='' className={styles.image} />
                </div>
            )}
            {Boolean(highlightIcon) && (
                <div className={styles.highlightCard}>
                    <EmojiIcon name={highlightIcon} version={spriteVersion} className={styles.highlightIcon} />
                    <p className={styles.highlightText}>{highlightText}</p>
                </div>
            )}
        </div>
    );
}

PauseSlideContentV10.propTypes = {
    imageSrc: PropTypes.string,
    heading: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired,
    highlightIcon: PropTypes.string,
    highlightText: PropTypes.node,
    spriteVersion: PropTypes.string.isRequired
};

PauseSlideContentV10.defaultProps = {
    imageSrc: '',
    highlightIcon: '',
    highlightText: ''
};

export {
    PauseSlideContentV10
};
